import type { Nullable } from "../../../typescript"

export default function isFloatArraySame(
  list1: Nullable<Float32Array | Float64Array>,
  list2: Nullable<Float32Array | Float64Array>
): boolean {
  // If either array is null or they are of different lengths, return false.
  if (!list1 || !list2 || list1.length !== list2.length) {
    return false
  }

  // neat optimization for large array buffers
  if (list1.length > 100) {
    list1 = new Uint32Array(list1.buffer) as unknown as Float32Array
    list2 = new Uint32Array(list2.buffer) as unknown as Float32Array
  }

  // Check if every number in list1 matches the corresponding number in list2.
  // if the arrays are the same length but not the same list of ents,
  // then the last item is more likely to be different
  // and the first items are more likely to be the same.
  for (let i = list1.length - 1; i >= 0; i--) {
    if (list1[i] !== list2[i]) {
      return false
    }
  }
  return true
}